import { render, staticRenderFns } from "./PalletSide.vue?vue&type=template&id=07e29c49&"
import script from "./PalletSide.vue?vue&type=script&lang=js&"
export * from "./PalletSide.vue?vue&type=script&lang=js&"
import style0 from "./PalletSide.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports